'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ = require('../');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var ModalAction = function ModalAction(props) {
    var closeAfterClick = props.closeAfterClick,
        closeModal = props.closeModal,
        onClick = props.onClick,
        rest = __rest(props, ["closeAfterClick", "closeModal", "onClick"]);

    var handleClick = function handleClick(e) {
        if (onClick) {
            onClick(e);
        }
        if (closeAfterClick) {
            closeModal(e);
        }
    };
    var buttonProps = Object.assign({}, rest, { onClick: handleClick });
    return _react2.default.createElement(_.Button, Object.assign({}, buttonProps));
};
ModalAction.propTypes = {
    closeAfterClick: _propTypes2.default.bool,
    closeModal: _propTypes2.default.func,
    onClick: _propTypes2.default.func
};
exports.default = ModalAction;
//# sourceMappingURL=ModalAction.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Modal/ModalAction.js